export const validateNewAdvocateData = (data) => {
    const errors = {};

    // Validate name
    if (typeof data.name !== 'string' || data.name.trim() === '') {
        errors.name = 'Name is required ';
    }

    // Validate relationshipType
    if (typeof data.relationshipType !== 'string' || data.relationshipType.trim() === '') {
        errors.relationshipType = 'Relationship Type is required ';
    }

    // Validate relativeName
    if (typeof data.relativeName !== 'string' || data.relativeName.trim() === '') {
        errors.relativeName = 'Relative Name is required ';
    }

    // Validate advocateBarId
    if (typeof data.advocateBarId !== 'string' || data.advocateBarId.trim() === '') {
        errors.advocateBarId = 'Advocate Bar ID is required ';
    }


    if (typeof data.mobileno !== 'string' || data.mobileno.trim() === '') {
        errors.mobileno = 'Mobile number is required';
    } else if (!/^\d{10}$/.test(data.mobileno)) {
        errors.mobileno = 'Mobile number must be exactly 10 digits';
    }

    // if (data.mobileno2 && !/^\d{10}$/.test(data.mobileno2)) {
    //     errors.mobileNo2 = 'Invalid secondary mobile number';
    //   }

    // Validate email
    if ((data.email) && (typeof data.email !== 'string' || data.email.trim() === '' || !isValidEmail(data.email))) {
        errors.email = 'Email is required and must be a valid email address';
    }

    // Validate dateOfBirth
    if (!data.dateOfBirth) {
        errors.dateOfBirth = 'Date of Birth is required';
    }

    // // Validate yearOfExperience
    // if (data.yearOfExperience < 0) {
    //     errors.yearOfExperience = 'Year of Experience must be a non-negative number';
    // }


    // Validate fees
    // if (!data.membershipFeesTypeId){
    //     errors.membershipFeesTypeId = 'Fees Type is Required ';
    // }

    // Validate permanentAddress
    if (typeof data.permanentAddress !== 'string' || data.permanentAddress.trim() === '') {
        errors.permanentAddress = 'Permanent Address is required ';
    }

    // // Validate localAddress
    // if (typeof data.localAddress !== 'string' || data.localAddress.trim() === '') {
    //     errors.localAddress = 'Local Address is required ';
    // }

    return errors;
}

function isValidEmail(email) {
    // Simple email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
